export default Object.freeze({
  ContinueAlways: 'continue-always',
  ThrowErrorIfAnyFailed: 'throw-error-if-any-failed',
  ThrowErrorIfAllFailed: 'throw-error-if-all-failed',
});
